var map = {
	"./calendar.svg": "3Nbk",
	"./history.svg": "iDeL",
	"./home.svg": "vIvP",
	"./racket-black.svg": "0Gd4",
	"./racket-red.svg": "r4cI",
	"./rackets.svg": "bRx4"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5lmF";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg ^\.\/.*\.svg$
// module id = 5lmF
// module chunks = 1